import { addDays, isAfter } from 'date-fns';

import NotificationsState from './state';

/**
 * Get unseenNotifications.
 */

export const getUnseenAndValidNotifications = () =>
  NotificationsState.notifications.filter((item) => {
    const endDate = new Date(item.endDate);
    return isAfter(addDays(endDate, 1), new Date()) && !item.hasSeen;
  });
